/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from "react";
import Container from "common/components/Container/Container";
import i18n from "internationalization/i18n";
import { useGetChargersQuery } from "services/chargersService";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "../../redux/combineReducers";
import useWindowDimensions, { counterCommonItemsArrays, decodeJWT, getDataToDisplay } from "../../common/functions";
import { Button, Space, Table, Tag, Select } from "antd";
import type { ColumnsType } from 'antd/es/table';
import "./Chargers.less";
import SelectFilter from "../../common/components/Select/Select";
import ChargersTable from "../../common/components/ChargersTable/ChargersTable";
import ChargerId from "./components/ChargerId/ChargerId";
import { chargersApi } from "../../services/chargersService";
import { useGetStationsQuery } from "../../services/stationsService";
import { emailToUsername, getUpperCase } from "../../common/utils";
import { ChargerItem } from "services/utils/interfaces";
import { dashboardApi,useGetMenuQuery } from "services/dashboardService";

type Props = {
	shouldRefresh: boolean,
};

export type Chargers = Array<ChargerItem>;

const Chargers: React.FC<Props> = ({ shouldRefresh }): React.ReactElement => {

	const getFilterBy = (): string | undefined =>
		filter && [i18n.t("chargers.station"), i18n.t("chargers.type"), i18n.t("chargers.status")].includes(filter) ? filter : undefined;

	

	const getKey = (filterBy?: string): string | null =>
		filterBy
			? (filterBy === "Station" ? "stationId" : filterBy.toLowerCase())
			: null;

	const getSortBy = (sort: string | null): string | undefined => sort ? sort : undefined;

	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const { stations1 } = useSelector(
		(state: rootReducerType) => state.stationsReducer
	);

	// const [menuData ,setMenuData]  = useState([])

    const menuData = useGetMenuQuery(stations1).data

	const filterStation = (stationId: any) => {
		if (filter !== "Station") return stationId;
		if (menuData && stationId) {
			const menfil = menuData[0].Dashboard.filter((item) => {
				if(item != "All") {
					return item
				}
			})
			const menuFind = menfil.find((item) => {
				return item.stationName == stationId
			})

			return menuFind['locationId.stationId']
		}
	}

	const [stationData, setStationData] = useState<any>([])

	const filterStationData = () => {
		if (menuData) {
			const menuFil = menuData[0].Dashboard.filter((item) => {
				if(item !== "All") {
					return item
				}
			})

			return menuFil.map((item) => {
				return item.stationName
			})
		}
	}

	const getFilterQueryString = (
		key: string | null,
		filterBy: string | undefined,
		filterValue: string | null
	) =>
		filterBy && filterStation(filterValue)
			? key?.toLowerCase() + "_is_" + filterStation(filterValue) 
			: undefined;

	useEffect(() => {
		setStationData(filterStationData()) 
	}, [menuData])

	const [limit] = useState(10);
	const [offset, setOffset] = useState<number>(0);
	const [previousOffset, setPreviousOffset] = useState<number>(offset);

	const [chargers, setChargers] = useState<Chargers>([]);

	const statusData = [
		i18n.t("chargers.available"),
		i18n.t("chargers.inUse"),
		i18n.t("chargers.unavailable"),
		i18n.t("chargers.offline"),
		i18n.t("chargers.faulted")
	];
	const typeData = [i18n.t("chargers.level2"), i18n.t("chargers.dcfc")];
	const stations = useGetStationsQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email)
	}).data;
	// const stationData = stations ? Object.keys(stations) : [];

	const dispatch = useDispatch();
 
	const [filter, setFilter] = useState<string | null>(null);
	const [filterValue, setFilterValue] = useState<string | null>(null);
	const [sort, setSort] = useState<string | null>(null);
	const [reset, setReset] = useState(false);

	const { data, refetch } = useGetChargersQuery({
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
		limit: String(limit),
		offset: String(offset < 0 ? 0 : offset),
		sortBy: getSortBy(sort),
		filterBy: getFilterQueryString(getKey(getFilterBy()), getFilterBy(), filterValue),
	});

	useEffect(() => {
		
		if (offset < previousOffset) return;
		if (offset === previousOffset) {
			const tempOffset = offset < 0 ? 0 : offset;
			dispatch(
				chargersApi.endpoints.getChargers.initiate(
					{
						userName: emailToUsername(decodeJWT(isLoggedIn).email),
						limit: String(limit),
						offset: String(tempOffset),
						sortBy: getSortBy(sort),
						filterBy: getFilterQueryString(getKey(getFilterBy()), getFilterBy(), filterValue),
					},
					{ subscribe: false, forceRefetch: true }
				)
			);
		}
		// setReset(false);
	}, [offset, filterValue]);

	useEffect(() => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	}, [filterValue, sort]);

	useEffect(() => {
		if (!data?.items) return;
		const tempOffset = offset < 0 ? 0 : offset;
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
 
		const counterCommonItems = counterCommonItemsArrays(data.items, chargers);
		const newItems = JSON.parse(JSON.stringify(
			offset <= 0
				? [...data.items]
				: (counterCommonItems === 0
					? [...chargers, ...data.items]
					: [...chargers]
				)));
		setChargers(newItems);
		setPreviousOffset(offset);
	}, [JSON.stringify(data?.items), offset, reset]);

	useEffect(() => {
		if (!reset) {
			setReset(false);
		}
		refetch();
	}, [refetch, reset]);

	useEffect(() => {
		refetch();
	}, [shouldRefresh]);

	const selectItems = [{ option: "Station" }, { option: "Type" }, { option: "Status" }];

	const handleReset = () => {
		const tempOffset = offset <= 0 ? offset - 1 : 0;
		setReset(true);
		setFilter(null);
		setFilterValue(null);
		setSort(null);
		setOffset(tempOffset);
		setPreviousOffset(tempOffset);
	};


	const { width } = useWindowDimensions();


	interface DataType {
		key: string;
		name: string;
		age: number;
		address: string;
		tags: string[];
	}

	const columns: ColumnsType<any> = [
		{
			title: 'Charger Id',
			dataIndex: 'ChargerId',
			key: 'ChargerId',
			render: (text) => <div>{text}</div>,
		},
		{
			title: 'StationName',
			dataIndex: 'StationName',
			key: 'StationName',
		},
		{
			title: 'assigned',
			dataIndex: 'assigned',
			key: 'assigned',
		},
		{
			title: 'Status',
			key: 'Status',
			dataIndex: 'Status',
			render: (_, { Status }) => (
				<>
					{Status.map((tag) => {
						let color = tag.length > 5 ? '#2db7f5' : "#87d068";
						if (tag === 'loser') {
							color = 'volcano';
						}
						return (
							<Tag color={color} key={tag}>
								{tag.toUpperCase()}
							</Tag>
						);
					})}
				</>
			),
		},
		{
			title: 'Type',
			dataIndex: 'Type',
			key: 'Type',
		},
		{
			title: 'Sessions',
			dataIndex: 'Sessions',
			key: 'Sessions',
		},
		{
			title: 'Energy kWh',
			dataIndex: 'energyKwh',
			key: 'energyKwh',
		},
		{
			title: 'Revenue $',
			dataIndex: 'Revenue',
			key: 'Revenue',
		},
		{
			title: 'Pricing Plan',
			dataIndex: 'pricingPlan',
			key: 'pricingPlan',
		},
	];

	let dataTable: any[] = [];

	const list: any[] = []
	for (let i = 0; i < 100; i++) {
		list.push({
			key: i + '',
			ChargerId: 'John Brown',
			Station: 32,
			Location: 'New York No. 1 Lake Park',
			accessType: 'New York',
			Status: ['nice'],
			Type: 'Type' + i,
			Sessions: 'Sessions' + i,
			energyKwh: 'energyKwh' + i,
			Revenue: 'Revenue' + i,
			pricingPlan: 'pricingPlan' + i
		})
	}

	dataTable = list

	const handleChange = (value: string) => {
	};

	const [tabIndex, setTabIndex] = useState<string>("2")

	const handleHeaderRow = (columns) => {
		return {
			onClick: (e) => {
				if (e.target.innerHTML == "Charger Id") {
					setTabIndex("2")
				}
			},
		};
	};

	const onTabIndexChange = (tabIndex) => {
		setTabIndex(tabIndex)
	}

	return (
		width > 768 ? (
			<Container
				backButton={false}
				loadingPageName={i18n.t("chargers.pageName")}
				subTitle={i18n.t("chargers.subtitle")}
				renderCondition={data ? true : false}
			>
				{data ?
					(<div style={{ width: "100%" }} className="charge-content">
						<div className="charge-content-top">
						<div className="charge-content-top-text">Filters:</div>
							<SelectFilter
								selectedFilter={filter || undefined}
								selectedFilterValue={filterValue || undefined}
								setNewFilter={(value) => setFilter(value)}
								setNewFilterValue={(value) => setFilterValue(value)}
								items={selectItems}
								statusData={statusData}
								typeData={typeData}
								stationData={stationData}
								reset={reset}
								setReset={setReset}
							/>
							<Button onClick={handleReset} size="large" className="dark-button">Reset filters</Button>
						</div>

						<ChargersTable
							limit={limit}
							offset={offset < 0 ? 0 : offset}
							setOffset={setOffset}
							data={getDataToDisplay(chargers, limit, offset)}
							setNewSort={(value) => setSort(value)}
							shouldReset={(value) => setReset(value)}
							reset={reset}
							length={chargers.length + (chargers.length < limit ? 0 : 1)}
						/>
					</div>) :
					null}
			</Container>
		) : (
			<Container
					backButton={false}
					loadingPageName={i18n.t("chargers.pageName")}
					subTitle={i18n.t("chargers.subtitle")}
					renderCondition={data ? true : false}
				>
					<div style={{ width: '100%' }}>
						<Button onClick={handleReset} className="dark-button">Reset filters</Button>
						<div style={{ marginTop: "auto", marginBottom: "auto" }}>
							<SelectFilter
								selectedFilter={filter || undefined}
								selectedFilterValue={filterValue || undefined}
								setNewFilter={(value) => setFilter(value)}
								setNewFilterValue={(value) => setFilterValue(value)}
								items={selectItems}
								statusData={statusData}
								typeData={typeData}
								stationData={stationData}
								reset={reset}
								setReset={setReset}
							/>
						</div>
					</div>
					{data ?
					(
						<div style={{ marginTop: "10px" }} className="table">
							<ChargersTable
								limit={limit}
								offset={offset < 0 ? 0 : offset}
								setOffset={setOffset}
								data={getDataToDisplay(chargers, limit, offset)}
								setNewSort={(value) => setSort(value)}
								shouldReset={(value) => setReset(value)}
								reset={reset}
								length={chargers.length + (chargers.length < limit ? 0 : 1)}
							/>
						</div>) :
					null}
				</Container>)
		// 		width > 768 ? (
		// 			<Container
		// 	backButton={false}
		// 	loadingPageName={i18n.t("chargers.pageName")}
		// 	subTitle={i18n.t("chargers.subtitle")}
		// 	renderCondition={data ? true : false}
		// >
		// 	{tabIndex == "1" ? <div className="charge-content">
		// 		<div className="charge-content-top">
		// 			<div className="charge-content-top-text">STATIONS:</div>
		// 			<Select
		// 				defaultValue="lucy"
		// 				style={{ width: 120 }}
		// 				onChange={handleChange}
		// 				options={[
		// 					{ value: 'jack', label: 'Jack' },
		// 					{ value: 'lucy', label: 'Lucy' },
		// 					{ value: 'Yiminghe', label: 'yiminghe' },
		// 					{ value: 'disabled', label: 'Disabled', disabled: true },
		// 				]}
		// 			/>
		// 		</div>
		// 		<Table columns={columns} dataSource={dataTable} size="large" onHeaderRow={handleHeaderRow} />
		// 	</div> : <div className="charge-content">
		// 		<ChargerId onTabIndexChange={onTabIndexChange}/>
		// 	</div>
		// 	}
		// </Container>
		// 		) : (<Container
		// 			backButton={false}
		// 			loadingPageName={i18n.t("chargers.pageName")}
		// 			subTitle={i18n.t("chargers.subtitle")}
		// 			renderCondition={data ? true : false}
		// 		>
		// 			{/* {data ?
		// 				(<div style={{ height: "100%", width: "100%" }} className="table">
		// 					<ChargersTable
		// 						limit={limit}
		// 						offset={offset < 0 ? 0 : offset}
		// 						setOffset={setOffset}
		// 						data={getDataToDisplay(chargers, limit, offset)}
		// 						setNewSort={(value) => setSort(value)}
		// 						shouldReset={(value) => setReset(value)}
		// 						reset={reset}
		// 						length={chargers.length + (chargers.length < limit ? 0 : 1)}
		// 					/>
		// 				</div>) :
		// 				null} */}
		// 			{tabIndex == "1" ? <div className="charge-content" style={{width: '80vw', height: "100%"}}>
		// 				<div className="charge-content-top">
		// 					<div className="charge-content-top-text">STATIONS:</div>
		// 					<Select
		// 						defaultValue="lucy"
		// 						style={{ width: 120 }}
		// 						onChange={handleChange}
		// 						options={[
		// 							{ value: 'jack', label: 'Jack' },
		// 							{ value: 'lucy', label: 'Lucy' },
		// 							{ value: 'Yiminghe', label: 'yiminghe' },
		// 							{ value: 'disabled', label: 'Disabled', disabled: true },
		// 						]}
		// 					/>
		// 				</div>
		// 				<Table columns={columns} dataSource={dataTable} size="large" onHeaderRow={handleHeaderRow} />
		// 			</div> : <div className="charge-content" style={{width: '80vw', height: "100%"}}>
		// 				<ChargerId onTabIndexChange={onTabIndexChange}/>
		// 			</div>
		// 			}
		// 		</Container>)
		
	);
};

export default Chargers;
